import { Actor } from '@/types/actor';

export const ACTORS: Actor[] = [
  {
    id: 'actor-sarah-presenter',
    name: 'Sarah - Professional Presenter',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3b9c68c6-d145-4082-ae67-cdca4399c1e8.png',
    voice_id: 'S9NKLs1GeSTKzXd9D0Lf', // Bella from voices.ts
    category: 'professional',
    description: 'Professional female presenter perfect for business content',
    tags: ['business', 'female', 'professional'],
  },
  // afro-american  female voice
  {
    id: 'actor-lisa-marketer',
    name: 'Lisa - Marketing Expert',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/68616c16-0d11-4a02-aae1-faf679dddcaf.png',
    voice_id: 'h2dQOVyUfIDqY2whPOMo', // Dorothy from voices.ts
    category: 'professional',
    description: 'Energetic voice perfect for marketing videos',
    tags: ['marketing', 'female', 'energetic'],
  },
  {
    id: 'actor-emma-casual',
    name: 'Emma - Lifestyle Vlogger',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/ec4f3af1-b773-4498-b5e5-2f993c4bcc1d.png',
    voice_id: 'ZF6FPAbjXT4488VcRRnw', // Charlotte from voices.ts
    category: 'casual',
    description: 'Friendly and relatable for lifestyle content',
    tags: ['casual', 'female', 'young'],
  },
  {
    id: 'actor-alex-tech-expert',
    name: 'Alex - Tech Expert',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3bd598aaca656ba23b0f7cde29d326c0.png',
    voice_id: '3svOJAOhuPHXwQC2H5eq', // Brady J from voices.ts
    category: 'professional',
    description: 'Deep, engaging voice perfect for tech tutorials and reviews',
    tags: ['technology', 'male', 'young', 'professional'],
  },
  {
    id: 'actor-jessica-fitness',
    name: 'Jessica - Fitness Instructor',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f1e873e44346443b753c09bcfc5e4c7c.png',
    voice_id: 'pq3wL6Xv3fuEM14W6ZCg', // Crystal Clear from voices.ts
    category: 'professional',
    description:
      'Strong, energetic voice ideal for fitness and workout content',
    tags: ['fitness', 'female', 'young', 'energetic'],
  },
  {
    id: 'actor-james-news-anchor',
    name: 'James - News Anchor',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b2b5e3099c329f774f2c05e911bbc575.png',
    voice_id: 'XjLkpWUlnhS8i7gGz3lZ', // David Castlemore from voices.ts
    category: 'professional',
    description: 'Deep authoritative voice perfect for news and journalism',
    tags: ['news', 'male', 'middle-aged', 'authoritative'],
  },
  {
    id: 'actor-sophia-creative',
    name: 'Sophia - Creative Director',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/43ad7ec36825210445805aaf094670b9.png',
    voice_id: 'QI7MqdLSOT7Xq48Th0oc', // Emme from voices.ts
    category: 'professional',
    description:
      'Unique, artistic voice perfect for creative and design content',
    tags: ['creative', 'female', 'young', 'artistic'],
  },
  {
    id: 'actor-olivia-wellness',
    name: 'Olivia - Wellness Coach',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/92cf8b65135788e79498d0b40e05c5e6.png',
    voice_id: 'IEUDyekKvUpLhkH6PS1k', // Kiki from voices.ts
    category: 'wellness',
    description: 'Calm, soothing voice ideal for meditation and wellness',
    tags: ['wellness', 'female', 'middle-aged', 'calm'],
  },
  {
    id: 'actor-david-chef',
    name: 'David - Culinary Expert',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/862c81f690c51f873f75b856f9626d48.png',
    voice_id: 'bzhDZB4cGhEmQvjxPqqj', // Antonio - The Sneakerhead Chef from voices.ts
    category: 'professional',
    description: 'Calm, conversational voice perfect for cooking tutorials',
    tags: ['cooking', 'male', 'middle-aged', 'friendly'],
  },
  {
    id: 'actor-ryan-travel-guide',
    name: 'Ryan - Travel Guide',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b8d00541892061ab988fb98dc7cd389b.png',
    voice_id: 'q0IMILNRPxOgtBTS4taI', // Drew from voices.ts
    category: 'casual',
    description:
      'Neutral, engaging voice perfect for travel and adventure content',
    tags: ['travel', 'male', 'young', 'adventurous'],
  },
  {
    id: 'actor-victoria-financial',
    name: 'Victoria - Financial Advisor',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7babc62d7029695726d3d7305d3dd103.png',
    voice_id: 'H8bdWZHK2OgZwTN7ponr', // Saavi - Warm Finance Customer Care from voices.ts
    category: 'professional',
    description:
      'Pleasant, professional voice ideal for financial and business content',
    tags: ['finance', 'female', 'middle-aged', 'professional'],
  },
  {
    id: 'actor-marcus-motivational',
    name: 'Marcus - Motivational Speaker',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/75e8c91a039e752d8ca67e25c3bea934.png',
    voice_id: 'dtSEyYGNJqjrtBArPCVZ', // Titan from voices.ts
    category: 'professional',
    description: 'Crisp, powerful voice perfect for motivation and inspiration',
    tags: ['motivation', 'male', 'middle-aged', 'inspiring'],
  },
  {
    id: 'actor-mia-beauty',
    name: 'Mia - Beauty Expert',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c55f880528df13fb242c000e08c2b9d8.png',
    voice_id: 'T7eLpgAAhoXHlrNajG8v', // Gracie Valley from voices.ts
    category: 'professional',
    description:
      'Whisper-soft, friendly voice perfect for beauty and makeup tutorials',
    tags: ['beauty', 'female', 'young', 'friendly'],
  },
  {
    id: 'actor-tyler-gamer',
    name: 'Tyler - Gaming Streamer',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/61ee65bcb191e21895e78e3b8cc44fc4.png',
    voice_id: 'JOUWtlfdRuffI74LLmML', // Jet from voices.ts
    category: 'casual',
    description:
      'Anxious, energetic voice perfect for gaming and streaming content',
    tags: ['gaming', 'male', 'young', 'energetic'],
  },
  {
    id: 'actor-rachel-realtor',
    name: 'Rachel - Real Estate Agent',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/79d6a89781eebbeb8300842cd6b779fd.png',
    voice_id: '5Bd4WV6UTiSunxizNai6', // Leslie from voices.ts
    category: 'professional',
    description:
      'Calm, professional voice ideal for real estate and property tours',
    tags: ['real-estate', 'female', 'young', 'professional'],
  },
  {
    id: 'actor-brandon-podcast',
    name: 'Brandon - Podcast Host',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/26c4ef8b9fc62c5deff4575c658a7442.png',
    voice_id: 'vDchjyOZZytffNeZXfZK', // Mike from voices.ts
    category: 'casual',
    description:
      'Gentle, well articulated voice perfect for podcasts and interviews',
    tags: ['podcast', 'male', 'middle-aged', 'conversational'],
  },
  {
    id: 'actor-natalie-fashion',
    name: 'Natalie - Fashion Stylist',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/4c7784d4480350af5ad914e4b0caf8a7.png',
    voice_id: 'LTdCOVuNg0GlsSue75IB', // Francesca's Secret from voices.ts
    category: 'professional',
    description:
      'Emotional, expressive voice ideal for fashion and style content',
    tags: ['fashion', 'female', 'young', 'trendy'],
  },
  {
    id: 'actor-ethan-music',
    name: 'Ethan - Music Producer',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/bffd03c6a559fdf0b7ce52caca825e06.png',
    voice_id: 'SA7eD52NRr8WAehitVt1', // Tyler Cruz from voices.ts
    category: 'professional',
    description: 'Hoarse, creative voice perfect for music and audio content',
    tags: ['music', 'male', 'young', 'creative'],
  },
  {
    id: 'actor-catherine-legal',
    name: 'Catherine - Legal Advisor',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/299f0aca5ebfb084bcc6e9140491f876.png',
    voice_id: 'tdOAypddKoCTtFZLeKO2', // Vivienne Reed from voices.ts
    category: 'professional',
    description:
      'Pleasant, authoritative voice ideal for legal and professional advice',
    tags: ['legal', 'female', 'middle-aged', 'authoritative'],
  },
  {
    id: 'actor-derek-sports',
    name: 'Derek - Sports Commentator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e63a253bec8d8f7ec2aa11b22c81d09b.png',
    voice_id: 'lXyLz3Gu0YqdG8RfvIyZ', // John from voices.ts
    category: 'professional',
    description: 'Shouty, energetic voice perfect for sports commentary',
    tags: ['sports', 'male', 'middle-aged', 'energetic'],
  },
  {
    id: 'actor-hannah-medical',
    name: 'Dr. Hannah - Medical Professional',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f2de714fb61059d276157137248566c6.png',
    voice_id: 'CICpbs1ZGqlhQNbQmCUP', // Lauren - Medical from voices.ts
    category: 'professional',
    description:
      'Pleasant, professional voice ideal for medical and health information',
    tags: ['medical', 'female', 'middle-aged', 'professional'],
  },
  {
    id: 'actor-amanda-life-coach',
    name: 'Amanda - Life Coach',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/ba691e399bbdcf13ca62246c44e3e396.png',
    voice_id: 'tdOAypddKoCTtFZLeKO2', // Vivienne Reed from voices.ts
    category: 'wellness',
    description:
      'Gentle, warm voice perfect for life coaching and personal growth',
    tags: ['life-coach', 'female', 'middle-aged', 'warm'],
  },
  {
    id: 'actor-kevin-support',
    name: 'Kevin - Customer Support',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9152be56c45fb989becf336552db0fa4.png',
    voice_id: '3liN8q8YoeB9Hk6AboKe', // Lauren - Customer Care from voices.ts
    category: 'professional',
    description: 'Calm, helpful voice ideal for customer service and tutorials',
    tags: ['support', 'male', 'young', 'helpful'],
  },
  {
    id: 'actor-nathan-reviewer',
    name: 'Nathan - Product Reviewer',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3e021e9a1dd8d7218797fa9b9af193bc.png',
    voice_id: '4e32WqNVWRquDa1OcRYZ', // Ryan - Product Reviewer from voices.ts
    category: 'professional',
    description: 'Casual, conversational voice perfect for product reviews',
    tags: ['reviews', 'male', 'middle-aged', 'analytical'],
  },
  {
    id: 'actor-maya-yoga',
    name: 'Maya - Yoga Instructor',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9c7e3119bb5415b1080acb82f9207577.png',
    voice_id: 'tJ2B69tloiOhZn8Gk9Lp', // Maya from voices.ts
    category: 'wellness',
    description: 'Calm, meditative voice ideal for yoga and mindfulness',
    tags: ['yoga', 'female', 'young', 'peaceful'],
  },
  {
    id: 'actor-lily-influencer',
    name: 'Lily - Social Media Influencer',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0586a1649d98e759173234da1e510faf.png',
    voice_id: 'BAdH0bMfq6VleQGLXj38', // Tessa from voices.ts
    category: 'casual',
    description: 'Soft, friendly voice perfect for social media and ads',
    tags: ['social-media', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-jake-casual-creator',
    name: 'Jake - Casual Content Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8ab4d7d2f86c241e498f8c297351eaa2.png',
    voice_id: 'q0IMILNRPxOgtBTS4taI', // Drew from voices.ts
    category: 'casual',
    description: 'Neutral, engaging voice ideal for casual vlogs and ads',
    tags: ['content-creator', 'male', 'young', 'casual'],
  },
  {
    id: 'actor-zoe-genz',
    name: 'Zoe - Gen Z Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a9c03f1050be4e76e73d56ad9a6ad7bd.png',
    voice_id: 'fDeOZu1sNd7qahm2fV4k', // Luna from voices.ts
    category: 'casual',
    description: 'Emotional, youthful voice perfect for TikTok and social ads',
    tags: ['gen-z', 'female', 'young', 'trendy'],
  },
  {
    id: 'actor-chris-entrepreneur',
    name: 'Chris - Young Entrepreneur',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/6a8e6e1f5d1382dd42c11060978d8a9d.png',
    voice_id: '3svOJAOhuPHXwQC2H5eq', // Brady J from voices.ts
    category: 'casual',
    description: 'Crisp, confident voice ideal for startup and business ads',
    tags: ['entrepreneur', 'male', 'young', 'ambitious'],
  },
  {
    id: 'actor-sarah-student',
    name: 'Sarah - Student & Young Pro',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7e914c6f01a11b1183d2e64ae8632b9b.png',
    voice_id: 'QI7MqdLSOT7Xq48Th0oc', // Emme from voices.ts
    category: 'casual',
    description: 'Calm, relatable voice perfect for educational ads',
    tags: ['student', 'female', 'young', 'relatable'],
  },
  {
    id: 'actor-lucas-lifestyle',
    name: 'Lucas - Lifestyle Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e65759a168aa81fd0ffb587712338964.png',
    voice_id: 'vDchjyOZZytffNeZXfZK', // Mike from voices.ts
    category: 'casual',
    description: 'Casual, conversational voice ideal for lifestyle content',
    tags: ['lifestyle', 'male', 'young', 'casual'],
  },
  {
    id: 'actor-jennifer-mom',
    name: 'Jennifer - Everyday Mom',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0666c16e60a7adc31eb7e64aa5b4f878.png',
    voice_id: 'IEUDyekKvUpLhkH6PS1k', // Kiki from voices.ts
    category: 'casual',
    description: 'Gentle, warm voice perfect for family and lifestyle ads',
    tags: ['family', 'female', 'middle-aged', 'relatable'],
  },
  {
    id: 'actor-ben-explainer',
    name: 'Ben - Casual Explainer',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/956f53ef09f960d525a383c0d4a8a288.png',
    voice_id: '3svOJAOhuPHXwQC2H5eq', // Brady J from voices.ts
    category: 'casual',
    description: 'Calm, clear voice ideal for explainer videos and ads',
    tags: ['explainer', 'male', 'young', 'helpful'],
  },
  {
    id: 'actor-chloe-enthusiast',
    name: 'Chloe - Enthusiastic Presenter',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/14ae68cb07a321c13e61ec966f5c1670.png',
    voice_id: 'S9NKLs1GeSTKzXd9D0Lf', // Haley Maven from voices.ts
    category: 'casual',
    description: 'Strong, energetic voice perfect for upbeat ads and promos',
    tags: ['enthusiastic', 'female', 'young', 'bubbly'],
  },
  {
    id: 'actor-adam-friendly',
    name: 'Adam - Trustworthy Friend',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/24595d4f74dcc373e76c9edc5b4339d9.png',
    voice_id: 'dtSEyYGNJqjrtBArPCVZ', // Titan from voices.ts
    category: 'casual',
    description: 'Deep, trustworthy voice ideal for testimonials and ads',
    tags: ['trustworthy', 'male', 'young', 'friendly'],
  },
  {
    id: 'actor-maria-latina',
    name: 'Maria - Latina Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/6dbc3433cd0fef9c3c1e015c0e368886.png',
    voice_id: '8DzKSPdgEQPaK5vKG0Rs', // Vanessa from voices.ts
    category: 'casual',
    description: 'Sassy, youthful voice perfect for diverse UGC content',
    tags: ['latina', 'female', 'young', 'ugc'],
  },
  {
    id: 'actor-kai-asian',
    name: 'Kai - Asian Content Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/ff518f301ce151d9761e28b0be6b0951.png',
    voice_id: 'kdVjFjOXaqExaDvXZECX', // Burt from voices.ts
    category: 'casual',
    description: 'Asian American voice perfect for relatable UGC ads',
    tags: ['asian', 'male', 'young', 'ugc'],
  },
  {
    id: 'actor-layla-middle-eastern',
    name: 'Layla - Middle Eastern Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7ac8567c78e9082c64cfc28d2789dfc1.png',
    voice_id: 'mRdG9GYEjJmIzqbYTidv', // Sana from voices.ts
    category: 'casual',
    description: 'Middle-aged Arabic accent voice perfect for diverse content',
    tags: ['middle-eastern', 'female', 'young', 'ugc'],
  },
  {
    id: 'actor-jamal-african-american',
    name: 'Jamal - African American Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/48c45c7b5f7b36ba04d109077a9fa290.png',
    voice_id: 'Z7HhYXzYeRsQk3RnXqiG', // Attank from voices.ts
    category: 'casual',
    description: 'African accent voice perfect for diverse UGC content',
    tags: ['african-american', 'male', 'young', 'ugc'],
  },
  {
    id: 'actor-priya-indian',
    name: 'Priya - Indian Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f3ebab3468053e2e58c11c8b619479bd.png',
    voice_id: '5xCLWhlcvn6tclaU3yqb', // Anika from voices.ts
    category: 'casual',
    description: 'Indian accent voice perfect for diverse UGC ads',
    tags: ['indian', 'female', 'young', 'ugc'],
  },
  {
    id: 'actor-lars-nordic',
    name: 'Lars - Nordic Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0ee68caf4e8a1b9bf51237d0ea5c5c2e.png',
    voice_id: 'e6OiUVixGLmvtdn2GJYE', // Jonas from voices.ts
    category: 'casual',
    description: 'Swedish accent voice perfect for European UGC content',
    tags: ['nordic', 'male', 'young', 'ugc'],
  },
  {
    id: 'actor-mei-southeast-asian',
    name: 'Mei - Southeast Asian Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/456bf03c8d93bc02aceac6cea60b076e.png',
    voice_id: 'XrExE9yKIg1WjnnlVkGX', // Matilda from voices.ts
    category: 'casual',
    description: 'Warm, youthful voice perfect for Asian UGC content',
    tags: ['southeast-asian', 'female', 'young', 'ugc'],
  },
  {
    id: 'actor-carlos-latino',
    name: 'Carlos - Latino Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/327741e1bd0b761098833d8260bbe678.png',
    voice_id: 'AsHHje51j2aYdrvLDHfG', // Carlos from voices.ts
    category: 'casual',
    description: 'Young Spanish male voice perfect for Latino UGC content',
    tags: ['latino', 'male', 'young', 'ugc'],
  },
  {
    id: 'actor-sophia-mixed',
    name: 'Sophia - Mixed Heritage Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0172732060eae265a34f7a0eb3266d82.png',
    voice_id: 'EXAVITQu4vr4xnSDxMaL', // Bella from voices.ts
    category: 'casual',
    description: 'Soft, friendly voice perfect for diverse inclusive UGC',
    tags: ['mixed-race', 'female', 'young', 'ugc'],
  },
  {
    id: 'actor-amara-african',
    name: 'Amara - African Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/7790babc108ec7a55688ae6ecf02ee38.png',
    voice_id: '9Dbo4hEvXQ5l7MXGZFQA', // Olufunmilola from voices.ts
    category: 'casual',
    description: 'Young African female voice perfect for diverse UGC content',
    tags: ['african', 'female', 'young', 'ugc'],
  },
  {
    id: 'actor-emma-outdoor',
    name: 'Emma - Outdoor Enthusiast',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0252ebe216c4610c8f6032189bf55b6f.png',
    voice_id: 'XB0fDUnXU5powFXDhCwa', // Charlotte from voices.ts
    category: 'casual',
    description: 'Seductive, engaging voice perfect for outdoor and travel UGC',
    tags: ['outdoor', 'female', 'young', 'nature'],
  },
  {
    id: 'actor-noah-coffee-shop',
    name: 'Noah - Coffee Shop Regular',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2d0a166bbe7aeeff7de8a42115b0da21.png',
    voice_id: 'IKne3meq5aSn9XLyUdCD', // Charlie from voices.ts
    category: 'casual',
    description:
      'Casual, conversational voice ideal for cafe and lifestyle UGC',
    tags: ['cafe', 'male', 'young', 'casual'],
  },
  {
    id: 'actor-alex-urban',
    name: 'Alex - Urban Explorer',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/d3d5ec52584d3599315e3f58c5939ed7.png',
    voice_id: 'AZnzlk1XvdvUeBnXmlld', // Domi from voices.ts
    category: 'casual',
    description: 'Strong, energetic voice perfect for urban and street UGC',
    tags: ['urban', 'female', 'young', 'street'],
  },
  {
    id: 'actor-jack-beach',
    name: 'Jack - Beach Lifestyle',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/6bf82a4f0542005411d2639a4374f661.png',
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ', // Liam from voices.ts
    category: 'casual',
    description: 'Neutral, engaging voice ideal for beach and vacation UGC',
    tags: ['beach', 'male', 'young', 'vacation'],
  },
  {
    id: 'actor-megan-park',
    name: 'Megan - Park & Outdoors',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/264d4f3caabeb5704db44e261434bdd3.png',
    voice_id: 'LcfcDJNUP1GQjkzn1xUU', // Emily from voices.ts
    category: 'casual',
    description: 'Calm, fresh voice perfect for outdoor and wellness UGC',
    tags: ['park', 'female', 'young', 'outdoor'],
  },
  {
    id: 'actor-daniel-library',
    name: 'Daniel - Book Lover',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2474ba1b7a5d189ed7f0556542003e9f.png',
    voice_id: 'GBv7mTt0atIp3Br8iCZE', // Thomas from voices.ts
    category: 'casual',
    description: 'Calm, thoughtful voice ideal for educational and book UGC',
    tags: ['library', 'male', 'young', 'intellectual'],
  },
  {
    id: 'actor-grace-garden',
    name: 'Grace - Garden Lover',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/17399d3067813e5a91bef8e4717e18ea.png',
    voice_id: 'oWAxZDx7w5VEj9dCyTzz', // Grace from voices.ts
    category: 'casual',
    description: 'Gentle, peaceful voice perfect for garden and home UGC',
    tags: ['garden', 'female', 'middle-aged', 'nature'],
  },
  {
    id: 'actor-mark-car-vlog',
    name: 'Mark - Car Vlogger',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8b388cdcb7b2701906707dbf7bcf4d27.png',
    voice_id: 't9pa8vZ7tCoTLCLirl6c', // Drew from voices.ts
    category: 'casual',
    description: 'Calm, conversational voice ideal for vlog and mobile UGC',
    tags: ['car-vlog', 'male', 'young', 'mobile'],
  },
  {
    id: 'actor-isabella-rooftop',
    name: 'Isabella - Rooftop Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/577ef34b228159e482d8a8256a12dfd2.png',
    voice_id: 'MF3mGyEYCl7XYWbV9V6O', // Elli from voices.ts
    category: 'casual',
    description: 'Emotional, expressive voice perfect for urban lifestyle UGC',
    tags: ['rooftop', 'female', 'young', 'urban'],
  },
  {
    id: 'actor-oliver-coworking',
    name: 'Oliver - Coworking Professional',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a2dc342596d3eb28b916352286e6efcc.png',
    voice_id: 'VR6AewLTigWG4xSOukaG', // Arnold from voices.ts
    category: 'casual',
    description:
      'Crisp, professional voice ideal for workspace and business UGC',
    tags: ['coworking', 'male', 'young', 'professional-casual'],
  },
  {
    id: 'actor-anna-direct',
    name: 'Anna - Direct Presenter',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c2b6150401b7b82458c86e1a3c76e336.png',
    voice_id: 'EXAVITQu4vr4xnSDxMaL', // Bella from voices.ts
    category: 'casual',
    description: 'Soft, friendly voice perfect for direct-to-camera ads',
    tags: ['direct', 'female', 'young', 'frontal'],
  },
  {
    id: 'actor-ryan-frontal',
    name: 'Ryan - Frontal Speaker',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/4f2d353b8ba536bb76d4b7e9e65ad0b3.png',
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ', // Liam from voices.ts
    category: 'casual',
    description:
      'Neutral, engaging voice ideal for direct camera presentations',
    tags: ['direct', 'male', 'young', 'frontal'],
  },
  {
    id: 'actor-melissa-business',
    name: 'Melissa - Business Casual',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2e6bdee3b0dc32dbd4823954774d365e.png',
    voice_id: 'pMsXgVXv3BLzUgSXRplE', // Serena from voices.ts
    category: 'casual',
    description: 'Pleasant, professional voice perfect for business casual UGC',
    tags: ['business-casual', 'female', 'middle-aged', 'frontal'],
  },
  {
    id: 'actor-max-energetic',
    name: 'Max - Energetic Host',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/55130cbf4073c3ae6c2375e03fd87fd8.png',
    voice_id: 'SOYHLrjzK2X1ezoPC6cr', // Harry from voices.ts
    category: 'casual',
    description: 'Anxious, energetic voice perfect for high-energy UGC',
    tags: ['energetic', 'male', 'young', 'frontal'],
  },
  {
    id: 'actor-claire-serene',
    name: 'Claire - Serene Speaker',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/8c1af66ffa5d6dba0bd5faa9b368a23d.png',
    voice_id: 'LcfcDJNUP1GQjkzn1xUU', // Emily from voices.ts
    category: 'casual',
    description: 'Calm, meditative voice ideal for wellness direct-to-camera',
    tags: ['serene', 'female', 'young', 'frontal'],
  },
  {
    id: 'actor-tom-approachable',
    name: 'Tom - Approachable Guide',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9cf888ec36edfd5a16967a742f4f86b0.png',
    voice_id: 'GBv7mTt0atIp3Br8iCZE', // Thomas from voices.ts
    category: 'casual',
    description: 'Calm, approachable voice perfect for tutorial UGC',
    tags: ['approachable', 'male', 'young', 'frontal'],
  },
  {
    id: 'actor-hannah-cheerful',
    name: 'Hannah - Cheerful Presenter',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e069240a87405c6f35797280574041f3.png',
    voice_id: 'AZnzlk1XvdvUeBnXmlld', // Domi from voices.ts
    category: 'casual',
    description: 'Strong, energetic voice perfect for cheerful UGC ads',
    tags: ['cheerful', 'female', 'young', 'frontal'],
  },
  {
    id: 'actor-robert-mature',
    name: 'Robert - Mature Professional',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/95d34a97bfc56ef1a5e4be8205737d56.png',
    voice_id: 'VR6AewLTigWG4xSOukaG', // Arnold from voices.ts
    category: 'casual',
    description: 'Crisp, mature voice ideal for professional casual UGC',
    tags: ['mature', 'male', 'middle-aged', 'frontal'],
  },
  {
    id: 'actor-julia-relatable',
    name: 'Julia - Relatable Friend',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/5534e717d9e98c95bfc088eab9bfa6a4.png',
    voice_id: 'oWAxZDx7w5VEj9dCyTzz', // Grace from voices.ts
    category: 'casual',
    description: 'Gentle, warm voice perfect for relatable friend UGC',
    tags: ['relatable', 'female', 'young', 'frontal'],
  },
  {
    id: 'actor-jason-modern',
    name: 'Jason - Modern Creator',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/23e35db802603259a95ffb5935b6ad17.png',
    voice_id: 'IKne3meq5aSn9XLyUdCD', // Charlie from voices.ts
    category: 'casual',
    description: 'Casual, conversational voice ideal for modern social UGC',
    tags: ['modern', 'male', 'young', 'frontal'],
  },
  {
    id: 'actor-yuki-asian-cardigan',
    name: 'Yuki - Asian Lifestyle',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/68208793411e2c5c6bd7c2e6031b6b46.png',
    voice_id: 'XrExE9yKIg1WjnnlVkGX', // Matilda from voices.ts
    category: 'casual',
    description:
      'Warm, youthful voice perfect for Asian lifestyle influencer content',
    tags: ['asian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-marcus-urban-bomber',
    name: 'Marcus - Urban Streetwear',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e19150c9baa7611203c005ef597fe868.png',
    voice_id: 'Z7HhYXzYeRsQk3RnXqiG', // Attank from voices.ts
    category: 'casual',
    description:
      'African accent voice perfect for urban streetwear influencer content',
    tags: ['black', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-isabella-latina-autumn',
    name: 'Isabella - Latina Fashion',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/25f764aebebbc7894b59a1ca853bf41a.png',
    voice_id: '8DzKSPdgEQPaK5vKG0Rs', // Vanessa from voices.ts
    category: 'casual',
    description:
      'Sassy valley girl voice perfect for Latina fashion influencer content',
    tags: ['latina', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-amir-velvet-luxury',
    name: 'Amir - Luxury Casual',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/cb04eaa89747570cfcc193ca8d3f685f.png',
    voice_id: 'fJE3lSefh7YI494JMYYz', // Richard from voices.ts
    category: 'casual',
    description:
      'Asian American voice perfect for luxury casual influencer content',
    tags: ['middle-eastern', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-priya-bright-yellow',
    name: 'Priya - Vibrant Indian',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3e81b8d27ab132adbf00137e3e4a4d97.png',
    voice_id: '5xCLWhlcvn6tclaU3yqb', // Anika from voices.ts
    category: 'casual',
    description:
      'Excited Indian accent voice perfect for vibrant influencer content',
    tags: ['indian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-leilani-tropical',
    name: 'Leilani - Tropical Vibes',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1ba6c41610a8473a5f5d4b8afdb0969a.png',
    voice_id: 'BAdH0bMfq6VleQGLXj38', // Charlotte from voices.ts
    category: 'casual',
    description:
      'Seductive voice perfect for tropical summer influencer content',
    tags: ['pacific-islander', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-tyler-vintage-band',
    name: 'Tyler - Vintage Casual',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/db740ee2fb63365f1ad6c56753ee7c6e.png',
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ', // Liam from voices.ts
    category: 'casual',
    description: 'Neutral voice perfect for vintage casual influencer content',
    tags: ['caucasian', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-amara-emerald-beauty',
    name: 'Amara - Elegant Beauty',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/30ca8ce2712bcab10fb57d397f907b8a.png',
    voice_id: '9Dbo4hEvXQ5l7MXGZFQA', // Olufunmilola from voices.ts
    category: 'casual',
    description:
      'Nigerian accent voice perfect for Black beauty influencer content',
    tags: ['black', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-jin-kpop-style',
    name: 'Jin - K-Fashion',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/daec2c28b0e40dd0739dae88ae80eb36.png',
    voice_id: 'WqVy7827vjE2r3jWvbnP', // Hyuk from voices.ts - Korean voice
    category: 'casual',
    description:
      'Soft emotional Korean voice perfect for K-fashion influencer content',
    tags: ['asian', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-maya-mixed-cozy',
    name: 'Maya - Mixed Heritage Cozy',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/02eda6b8a4fc5797ece085e742c96d42.png',
    voice_id: 'EXAVITQu4vr4xnSDxMaL', // Bella from voices.ts
    category: 'casual',
    description:
      'Soft friendly voice perfect for cozy diverse influencer content',
    tags: ['mixed-race', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-diego-summer-linen',
    name: 'Diego - Summer Casual',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/cef316d9f679b3c7c450bd096bf5edbd.png',
    voice_id: 'AsHHje51j2aYdrvLDHfG', // Carlos from voices.ts
    category: 'casual',
    description:
      'Young Spanish male voice perfect for summer Latino influencer content',
    tags: ['hispanic', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-angel-southeast-trendy',
    name: 'Angel - Southeast Asian Trendy',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/ec6e8ca25af078da5fb3688da852d29d.png',
    voice_id: 'lFjzhZHq0NwTRiu2GQxy', // Tri Nugraha Ramadhani from voices.ts
    category: 'casual',
    description:
      'Indonesian voice perfect for Southeast Asian trendy influencer content',
    tags: ['southeast-asian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-emma-genz-pastel',
    name: 'Emma - Gen Z Pastel',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f5451b17c21c9ecc6795a56ab25bc03b.png',
    voice_id: 'MF3mGyEYCl7XYWbV9V6O', // Elli from voices.ts
    category: 'casual',
    description:
      'Emotional youthful voice perfect for Gen Z pastel influencer content',
    tags: ['caucasian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-kwame-cultural',
    name: 'Kwame - African Cultural',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0edbb7d6d8856ef17bdd7315362beb90.png',
    voice_id: 'QLniWkGYsJa91mXrxl3c', // Eze from voices.ts
    category: 'casual',
    description:
      'Nigerian Igbo accent voice perfect for African cultural influencer content',
    tags: ['african', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-yasmin-elegant',
    name: 'Yasmin - Middle Eastern Elegance',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/5d2577c700e4941415279b4a73903d16.png',
    voice_id: 'mRdG9GYEjJmIzqbYTidv', // Sana from voices.ts
    category: 'casual',
    description:
      'Arabic accent voice perfect for elegant Middle Eastern influencer content',
    tags: ['middle-eastern', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-raj-modern-desi',
    name: 'Raj - Modern Desi',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/13eab95e67b5f6f69a4c51da3b194172.png',
    voice_id: 'VWAh9zdAr6qPRcTE1EEx', // Sanjay from voices.ts
    category: 'casual',
    description:
      'Deep Indian voice perfect for modern South Asian influencer content',
    tags: ['south-asian', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-sofia-athletic-latina',
    name: 'Sofia - Athletic Latina',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/5e89f3b94c20675f3ab23cb5a2527e10.png',
    voice_id: 'AZnzlk1XvdvUeBnXmlld', // Domi from voices.ts
    category: 'casual',
    description:
      'Strong energetic voice perfect for athletic Latina influencer content',
    tags: ['latina', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-dante-biracial-edgy',
    name: 'Dante - Biracial Edge',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/c76915a1301cbd07ed5266fd772a0bc8.png',
    voice_id: 'IKne3meq5aSn9XLyUdCD', // Charlie from voices.ts
    category: 'casual',
    description:
      'Casual conversational voice perfect for edgy biracial influencer content',
    tags: ['biracial', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-lily-cozy-autumn',
    name: 'Lily - Cozy Autumn',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/1710dd8a338aa6aff9e1bcaa8491c03f.png',
    voice_id: 'oWAxZDx7w5VEj9dCyTzz', // Grace from voices.ts
    category: 'casual',
    description: 'Gentle warm voice perfect for cozy autumn influencer content',
    tags: ['caucasian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-takoda-native',
    name: 'Takoda - Native Heritage',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b7f2813a473e50ebe00293b192d6dd28.png',
    voice_id: 'GBv7mTt0atIp3Br8iCZE', // Thomas from voices.ts
    category: 'casual',
    description:
      'Calm meditative voice perfect for Native American influencer content',
    tags: ['native-american', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-hana-kawaii',
    name: 'Hana - Kawaii Style',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/6feaf1db1a88ed42cfdfb1d88fa0924a.png',
    voice_id: 'XrExE9yKIg1WjnnlVkGX', // Matilda from voices.ts
    category: 'casual',
    description:
      'Warm audiobook voice perfect for kawaii Asian influencer content',
    tags: ['east-asian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-blake-surfer',
    name: 'Blake - Surfer Lifestyle',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/d6281e50a26aa273ec7fcd3ddb8e4ea3.png',
    voice_id: 'IKne3meq5aSn9XLyUdCD', // Charlie from voices.ts
    category: 'casual',
    description:
      'Casual conversational voice perfect for coastal surfer influencer content',
    tags: ['caucasian', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-zara-african-bold',
    name: 'Zara - Bold African',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/3edd9263b3e41925226f75ec46b8bee3.png',
    voice_id: '9Dbo4hEvXQ5l7MXGZFQA', // Olufunmilola from voices.ts
    category: 'casual',
    description:
      'Nigerian voice perfect for bold African fashion influencer content',
    tags: ['african', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-ananya-modern-indian',
    name: 'Ananya - Modern Indian',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/b193b6453313992dd8aee69a4723cb9c.png',
    voice_id: '2zRM7PkgwBPiau2jvVXc', // Monika Sogam from voices.ts
    category: 'casual',
    description:
      'Indian English accent voice perfect for modern Indian influencer content',
    tags: ['indian', 'female', 'young', 'influencer'],
  },
  {
    id: 'actor-diego-mixed-casual',
    name: 'Diego - Mixed Casual',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/f73ae70024d8626cddae2857e98e97ad.png',
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ', // Liam from voices.ts
    category: 'casual',
    description:
      'Neutral engaging voice perfect for mixed heritage everyday influencer content',
    tags: ['mixed-latino', 'male', 'young', 'influencer'],
  },
  {
    id: 'actor-sophie-car-vlog',
    name: 'Sophie - Car Vlogger',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/98e5cbe3e17fb483e509c9eb70132eeb.png',
    voice_id: 'EXAVITQu4vr4xnSDxMaL', // Bella from voices.ts
    category: 'casual',
    description: 'Soft friendly voice perfect for car vlogs and mobile content',
    tags: ['car-talk', 'female', 'young', 'vlog'],
  },
  {
    id: 'actor-ryan-podcast-host',
    name: 'Ryan - Podcast Professional',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0c3219d5db11d6d658b99269fe931082.png',
    voice_id: 'qQv4kpHuinkiwCWyCGXk', // Hal from voices.ts
    category: 'casual',
    description: 'Gentle articulated voice perfect for podcast interviews',
    tags: ['podcast', 'male', 'young', 'interviewer'],
  },
  {
    id: 'actor-alex-gaming-stream',
    name: 'Alex - Gaming Streamer Pro',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/90d0036c3ed48e2fb7edcfd3f16109db.png',
    voice_id: 'SOYHLrjzK2X1ezoPC6cr', // Harry from voices.ts
    category: 'casual',
    description: 'Anxious energetic voice perfect for gaming streams',
    tags: ['streaming', 'male', 'young', 'gamer'],
  },
  {
    id: 'actor-jessica-mirror-selfie',
    name: 'Jessica - Mirror Selfie',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/e63a2d7f3673d0868a5a243d5f4441a6.png',
    voice_id: 'MF3mGyEYCl7XYWbV9V6O', // Elli from voices.ts
    category: 'casual',
    description: 'Emotional expressive voice perfect for mirror selfie content',
    tags: ['selfie', 'female', 'young', 'social-media'],
  },
  {
    id: 'actor-david-security-cam',
    name: 'David - Security Footage',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/bb26de784970628b0253a68fcd3e1c62.png',
    voice_id: 'GBv7mTt0atIp3Br8iCZE', // Thomas from voices.ts
    category: 'casual',
    description: 'Calm voice perfect for documentary style footage content',
    tags: ['documentary', 'male', 'young', 'elevated-angle'],
  },
  {
    id: 'actor-jake-car-casual',
    name: 'Jake - Car Talk Casual',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/630cab8610198b7679b7421828bc897b.png',
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ', // Liam from voices.ts
    category: 'casual',
    description: 'Neutral engaging voice perfect for casual car vlogs',
    tags: ['car-vlog', 'male', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-kenya-car-vlog',
    name: 'Kenya - Car Vlog Queen',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/a6dfe64da7dc1fd79042fe90a87f1c56.png',
    voice_id: 'ThT5KcBeYPX3keUQqHPh', // Dorothy from voices.ts
    category: 'casual',
    description: 'Pleasant voice perfect for African American car vlogs',
    tags: ['car-vlog', 'female', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-miguel-car-drive',
    name: 'Miguel - Drive Time',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/dc3dba458743cdb936617cdcc67cd59f.png',
    voice_id: 'AsHHje51j2aYdrvLDHfG', // Carlos from voices.ts
    category: 'casual',
    description: 'Young Spanish male voice perfect for Latino car vlogs',
    tags: ['car-vlog', 'male', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-mei-car-talk',
    name: 'Mei - Asian Car Talk',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/67996c1a6e99ae4f7ca0564ea6e9b372.png',
    voice_id: 'XrExE9yKIg1WjnnlVkGX', // Matilda from voices.ts
    category: 'casual',
    description: 'Warm audiobook voice perfect for Asian car vlogs',
    tags: ['car-vlog', 'female', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-rachel-car-cool',
    name: 'Rachel - Car Cool',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/0a27d99d4315e31c1554e09d7135831a.png',
    voice_id: 'EXAVITQu4vr4xnSDxMaL', // Bella from voices.ts
    category: 'casual',
    description: 'Soft friendly voice perfect for cool casual car vlogs',
    tags: ['car-vlog', 'female', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-arjun-car-modern',
    name: 'Arjun - Modern Car Vlog',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/914bafa24f997f7033e96127f33130e4.png',
    voice_id: 'VWAh9zdAr6qPRcTE1EEx', // Sanjay from voices.ts
    category: 'casual',
    description: 'Deep Indian voice perfect for modern South Asian car vlogs',
    tags: ['car-vlog', 'male', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-leila-car-chat',
    name: 'Leila - Car Chat',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/cc4b6196f6fc5306ad9b6a6fe0374492.png',
    voice_id: 'mRdG9GYEjJmIzqbYTidv', // Sana from voices.ts
    category: 'casual',
    description: 'Arabic accent voice perfect for Middle Eastern car vlogs',
    tags: ['car-vlog', 'female', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-omar-car-urban',
    name: 'Omar - Urban Car Drive',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/2a183eb6cbb7b28cce19168dc4db6c8e.png',
    voice_id: 'IKne3meq5aSn9XLyUdCD', // Charlie from voices.ts
    category: 'casual',
    description: 'Casual conversational voice perfect for urban car vlogs',
    tags: ['car-vlog', 'male', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-ava-car-everyday',
    name: 'Ava - Everyday Drive',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9a56e86842240208507a6debfcb74b41.png',
    voice_id: 'lFjzhZHq0NwTRiu2GQxy', // Tri from voices.ts
    category: 'casual',
    description: 'Indonesian voice perfect for Southeast Asian car vlogs',
    tags: ['car-vlog', 'female', 'young', 'dashboard-cam'],
  },
  {
    id: 'actor-william-car-pro',
    name: 'William - Professional Drive',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/9b1db3df6ddaf6b70586cb47c76b4f7c.png',
    voice_id: 'VR6AewLTigWG4xSOukaG', // Arnold from voices.ts
    category: 'casual',
    description:
      'Crisp professional voice perfect for business casual car vlogs',
    tags: ['car-vlog', 'male', 'middle-aged', 'dashboard-cam'],
  },
  {
    id: 'actor-santa-classic',
    name: 'Santa Claus - Classic',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/693af4c5-20b1-45f8-85ae-8260409ebffe.png',
    voice_id: 'uDsPstFWFBUXjIBimV7s', // Mr. Claus - Classic Jolly Santa from voices.ts
    category: 'professional',
    description:
      'Classic jolly Santa Claus voice perfect for holiday greetings and festive messages',
    tags: ['holiday', 'male', 'old', 'santa', 'christmas'],
  },
  {
    id: 'actor-santa-storyteller',
    name: 'Santa Claus - Storyteller',
    photo:
      'https://media.easy-peasy.ai/27feb2bb-aeb4-4a83-9fb6-8f3f2a15885e/97ee6d1e-7a8f-4488-bfd7-2cfd1d7e91a7.png',
    voice_id: '1wg2wOjdEWKA7yQD8Kca', // Father Christmas - Magical Storyteller from voices.ts
    category: 'professional',
    description:
      'Magical storyteller Santa voice ideal for holiday tales and heartwarming narratives',
    tags: ['holiday', 'male', 'old', 'santa', 'christmas', 'storytelling'],
  },
];
